import { fetcher } from '@commenda/utils';

export interface CloneDemoCompanyBody {
  targetUserId: string;
  cloneOptions?: {
    demoCompany?: boolean;
    transferPricing?: boolean;
    globalIndirectTax?: boolean;
  };
}

export interface CloneDemoCompanyResponse {
  company?: {
    id: number;
  };
  corporationIds?: number[];
  affiliateFirmId?: string;
}

export async function cloneDemoCompany(
  body: CloneDemoCompanyBody
): Promise<CloneDemoCompanyResponse> {
  const response = await fetcher('demo-company-clone', {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new Error('Failed to clone demo company');
  }

  return response.json() as Promise<CloneDemoCompanyResponse>;
}
